import styled from '@emotion/styled'

const Container = styled.section`
  --size: 100%;

  & {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-flow: row nowrap;
  }

  .platform-link-button {
    background-color: ${({ theme }) => theme.colors.primary[400]};
    min-width: 160px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fs-300);
    transition: 350ms background;
  }

  .platform-link-button:hover {
    background-color: ${({ theme }) => theme.colors.primary[500]};
  }

  .platform-link-button:focus {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }

  .platform-link-button:active {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }
`

export default Container
